import { render, staticRenderFns } from "./addQualificationModel.vue?vue&type=template&id=4cf232b1&scoped=true"
import script from "./addQualificationModel.vue?vue&type=script&lang=js"
export * from "./addQualificationModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf232b1",
  null
  
)

export default component.exports